import React, { useState, useEffect } from 'react';
import { t } from '../i18n';

function Inbox({ user }) {
  const [convos, setConvos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) fetchInbox();
    const interval = setInterval(() => { if (user) fetchInbox(); }, 5000);
    return () => clearInterval(interval);
  }, [user]);

  const fetchInbox = async () => {
    try {
      const res = await fetch('/api/inbox/', {
        headers: { 'Authorization': `Token ${user.token}` }
      });
      const data = await res.json();
      setConvos(Array.isArray(data) ? data : []);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  if (!user) return (
    <div style={styles.container}>
      <h2 style={{ textAlign: 'center', color: '#6200ea' }}>🔑 Login Required</h2>
    </div>
  );

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>💬 Messages</h1>
      {loading ? <div style={styles.loading}>{t('loading')}</div> :
        convos.length === 0 ? (
          <div style={styles.empty}>
            <p style={{ fontSize: '48px' }}>💬</p>
            <p>{t('ib_empty')}</p>
            <p style={{ fontSize: '13px', color: '#999' }}>{t('ib_empty_hint')}</p>
          </div>
        ) : (
          <div style={styles.list}>
            {convos.map(c => (
              <a key={c.username} href={`/chat/${c.username}`} style={styles.item}>
                <div style={styles.avatarWrap}>
                  {c.avatar
                    ? <img src={c.avatar} alt={c.username} style={styles.avatar} />
                    : <div style={styles.avatarPlaceholder}>{c.username[0].toUpperCase()}</div>
                  }
                  {c.unread > 0 && <span style={styles.unreadBadge}>{c.unread}</span>}
                </div>
                <div style={styles.info}>
                  <div style={styles.name}>@{c.username}</div>
                  <div style={styles.lastMsg}>
                    {c.is_me ? 'You: ' : ''}{c.last_message.substring(0, 40)}{c.last_message.length > 40 ? '...' : ''}
                  </div>
                </div>
                <div style={styles.time}>{c.last_time}</div>
              </a>
            ))}
          </div>
        )
      }
    </div>
  );
}

const styles = {
  container: { maxWidth: '700px', margin: '20px auto', padding: '20px' },
  title: { color: '#6200ea', marginBottom: '20px' },
  loading: { textAlign: 'center', padding: '40px', color: '#999' },
  empty: { textAlign: 'center', padding: '60px', color: '#666' },
  list: { display: 'flex', flexDirection: 'column', gap: '8px' },
  item: { display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', backgroundColor: 'white', borderRadius: '12px', textDecoration: 'none', boxShadow: '0 2px 6px rgba(0,0,0,0.08)' },
  avatarWrap: { position: 'relative', flexShrink: 0 },
  avatar: { width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #6200ea' },
  avatarPlaceholder: { width: '48px', height: '48px', borderRadius: '50%', backgroundColor: '#6200ea', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '20px' },
  unreadBadge: { position: 'absolute', top: '-4px', right: '-4px', backgroundColor: '#ff4444', color: 'white', borderRadius: '50%', fontSize: '10px', width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' },
  info: { flex: 1 },
  name: { fontWeight: 'bold', color: '#333', fontSize: '15px' },
  lastMsg: { color: '#999', fontSize: '13px', marginTop: '3px' },
  time: { color: '#bbb', fontSize: '11px', flexShrink: 0 },
};

export default Inbox;
